module.exports = __webpack_public_path__ + "media/images/icons/marker-610a68239fa1a2d3686d7d52b2089ce3.svg";